<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.6"
      d="M101.033 35.6558H35.3432V107.842H101.033V35.6558Z"
      fill="var(--jd-color-line-100)"
    />
    <path
      d="M95.5623 35.9265H49.8224L22.0676 42.8293V51.7672C22.0676 51.7672 47.4681 62.3339 46.7955 65.1778C46.1229 68.0217 85.4726 62.3339 85.4726 62.3339L95.5623 35.9265Z"
      fill="var(--jd-color-gray-4)"
    />
    <rect
      x="15.3117"
      y="67.5984"
      width="64.9677"
      height="4.87258"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M10.8 28.8811V36.0997C10.8 39.6877 13.7087 42.5964 17.2968 42.5964H73.6021C77.1902 42.5964 80.0989 39.6877 80.0989 36.0997V28.881C80.0989 25.293 77.1902 22.3843 73.6021 22.3843H17.2968C13.7087 22.3843 10.8 25.293 10.8 28.8811Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M71.4365 30.3247H44.7275V34.6559H71.4365V30.3247Z"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="21.6281"
      cy="32.4903"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="27.4028"
      cy="32.4903"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="33.1778"
      cy="32.4903"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M10.8 53.4243V60.6429C10.8 64.231 13.7087 67.1397 17.2968 67.1397H73.6021C77.1902 67.1397 80.0989 64.231 80.0989 60.6429V53.4243C80.0989 49.8362 77.1902 46.9275 73.6021 46.9275H17.2968C13.7087 46.9275 10.8 49.8362 10.8 53.4243Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M60.6085 54.8682H44.7275V59.1993H60.6085V54.8682Z"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="21.6281"
      cy="57.0338"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="27.4028"
      cy="57.0338"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="33.1778"
      cy="57.0338"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M10.8 77.9677V85.1863C10.8 88.7744 13.7087 91.6831 17.2968 91.6831H73.6021C77.1902 91.6831 80.0989 88.7744 80.0989 85.1863V77.9677C80.0989 74.3796 77.1902 71.4709 73.6021 71.4709H17.2968C13.7087 71.4709 10.8 74.3797 10.8 77.9677Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M60.6085 79.4114H44.7275V83.7426H60.6085V79.4114Z"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="21.6281"
      cy="81.577"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="27.4028"
      cy="81.577"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <ellipse
      cx="33.1778"
      cy="81.577"
      rx="2.16559"
      ry="2.16559"
      fill="var(--jd-color-gray-4)"
    />
    <path
      d="M63.7742 81.938C63.7742 95.6922 75.0858 106.842 89.0394 106.842V57.0337C75.0858 57.0337 63.7742 68.1837 63.7742 81.938Z"
      fill="var(--jd-color-line-100)"
    />
    <path
      d="M89.4003 101.706C100.164 101.706 108.891 92.9803 108.891 82.2161C108.891 71.4519 100.164 62.7258 89.4003 62.7258C78.6361 62.7258 69.91 71.4519 69.91 82.2161C69.91 92.9803 78.6361 101.706 89.4003 101.706Z"
      fill="var(--jd-color-surface-400)"
      stroke="var(--jd-color-gray-6)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <circle
      cx="89.4003"
      cy="82.2161"
      r="14.6177"
      fill="var(--jd-color-gray-4)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M89.2603 73.283C87.8939 73.283 86.83 74.469 86.9779 75.8274L87.7586 82.9968C87.842 83.7632 88.4893 84.3438 89.2603 84.3438C90.0312 84.3438 90.6785 83.7632 90.7619 82.9968L91.5426 75.8274C91.6906 74.469 90.6266 73.283 89.2603 73.283ZM89.2903 89.7329C90.5542 89.7329 91.5787 88.7083 91.5787 87.4444C91.5787 86.1805 90.5542 85.156 89.2903 85.156C88.0264 85.156 87.0018 86.1805 87.0018 87.4444C87.0018 88.7083 88.0264 89.7329 89.2903 89.7329Z"
      fill="var(--jd-color-surface-400)"
    />
    <path
      d="M101.394 20.5181C101.899 21.5287 101.538 22.7559 100.528 23.2612L95.6911 25.7155C94.6805 26.2209 93.4533 25.8599 92.948 24.8493C92.4427 23.8387 92.8036 22.6115 93.8142 22.1062L98.6507 19.6519C99.6613 19.1466 100.888 19.5797 101.394 20.5181Z"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M91.2156 12L88.0395 17.7749"
      stroke="var(--jd-color-gray-4)"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 0
export default defineComponent({
  name: 'ServerEmpty',
  setup() {
    const ns = useNamespace('empty')
    return {
      ns,
      id: ++id,
    }
  },
})
</script>
